import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'closer-sync-auth-required-list',
	templateUrl: './required-list.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class RequiredListComponent {
	@Input() possessiveAdjective: 'your' | 'their' | 'its' | 'her' | 'his' =
		'your';
}
